import Link from 'next/link';

import { Lia } from 'src/components/ui/Lia';
import { Text } from 'src/components/ui/Text';
import { Title } from 'src/components/ui/Title';

const CookiesPolicy = () => {
  return (
    <div className="mx-auto max-w-2xl p-5 sm:px-0 sm:py-20">
      <Lia />

      <Title
        size="xl"
        className="my-10"
      >
        Política de cookies
      </Title>

      <Title>1. Introdução</Title>
      <Text className="mb-6 mt-4">
        A Política de Cookies descrita diz respeito à PLATAFORMA que o cliente está utilizando para consumir o serviço,
        visando uma melhor e mais cristalina experiência, apresentando o conceito de cookies, como os utilizamos (ou
        poderemos utilizar), para tornar mais agradável a navegação do usuário e, ainda, as possibilidades de
        customização do uso.
        <br />
        <br />
        Caso o usuário não concorde com o uso de Cookies da forma apresentada, poderá: (i) ajustar as configurações de
        seu navegador de internet para não permitir o uso de Cookies ou (ii) acessar o site de forma limitada/não
        acessar o site.
        <br />
        <br />
        Lembramos que desabilitar o uso de Cookies poderá impactar sua experiência ao navegar no site.
        <br />
        <br />
        Recomendamos também a leitura da nossa{' '}
        <Link
          className="underline"
          href="/politica-de-privacidade"
        >
          Política de Privacidade
        </Link>
        , onde trazemos a você mais informações sobre nosso compromisso com a sua privacidade e a proteção dos seus
        dados pessoais.
      </Text>

      <Title>2. O que são cookies?</Title>
      <Text className="mb-6 mt-4">
        Cookies são pequenos arquivos digitais em formato de texto que são armazenados no seu dispositivo (notebook,
        desktop, computadores em geral, smartphone, tablet, etc.) pelo navegador de internet e que guardam informações
        relacionadas às suas preferências, como: idioma preferido, localização, recorrência das suas sessões, e outras
        variáveis que os desenvolvedores consideram relevantes para tornar a sua experiência muito mais eficiente.
      </Text>

      <Title>3. E para que servem?</Title>
      <Text className="mb-6 mt-4">
        Os Cookies servem para aprimorar a experiência, tanto em termos de performance, como em termos de usabilidade,
        vez que os conteúdos disponibilizados serão direcionados às suas necessidades e expectativas.
        <br />
        <br />
        Também poderão ser utilizados para compilar estatísticas anônimas e agregadas que permitem entender como você
        utiliza o site, bem como para aprimorar suas estruturas e conteúdo. Por serem estatísticas anônimas, não é
        possível identificá-lo pessoalmente por meio destes dados.
        <br />
        <br />A utilização de Cookies é algo muito comum em qualquer plataforma digital atualmente. O seu uso não
        prejudica de forma alguma os dispositivos em que são armazenados.
      </Text>

      <Title>4. Quais cookies utilizamos?</Title>
      <Text
        className="mb-6 mt-4"
        as="div"
      >
        Nós, da LIA, podemos utilizar Cookies próprios e de terceiros no site, os quais podem ser classificados quanto à
        sua temporalidade:
        <br />
        <br />
        <strong>Cookies de Sessão</strong> - são os Cookies temporários que permanecem arquivados até que você saia do
        site ou encerre a aplicação utilizada.
        <br />
        <br />
        <strong>Cookies Persistentes</strong> - são os Cookies que ficam armazenados no dispositivo do Usuário até que
        sejam excluídos (o tempo que o Cookie permanecerá no dispositivo depende do seu “tempo de vida” e das
        configurações do seu navegador de internet).
        <br />
        <br />
        Estes podem ser <u>subdivididos</u> em:
        <br />
        <br />
        <ul>
          <li>
            <strong>Cookies Estritamente Necessários</strong> - permitem a navegação e utilização das aplicações, bem
            como o acesso a áreas seguras do site. Sem estes Cookies, o site não funciona corretamente.
          </li>
          <li>
            <strong>Cookies Analíticos</strong> - coletam dados estatísticos anônimos com a finalidade de analisar a
            utilização do site e seu respectivo desempenho.
          </li>
          <li>
            <strong>Cookies de Funcionalidade</strong> - são utilizados para assegurar a disponibilização de
            funcionalidades adicionais do site ou para guardar as preferências definidas pelo usuário ao navegar na
            internet, sempre que utilizar o mesmo dispositivo.
          </li>
          <li>
            <strong>Cookies de Publicidade</strong> - coletam as informações de sua visita em nosso site para que as
            propagandas nele dispostas sejam mais relevantes para você e de acordo com os seus interesses. Geralmente
            estão atrelados a Cookies de propriedade de terceiros. Caso você desabilite estes cookies, note que você
            ainda visualizará as publicidades, mas elas serão personalizadas às suas preferências.
          </li>
        </ul>
      </Text>

      <Title>5. Informações detalhadas sobre cookies</Title>
      <Text className="mb-6 mt-4">
        Você encontra a lista completa de cookies{' '}
        <Link
          target="_blank"
          href="https://docs.google.com/document/d/e/2PACX-1vTP2FRXcnRpIEo_ArJloLV_z40gK5KCliW9w_CiEM9x7A7n26GNr4j5HQin8cHydA/pub"
          className="underline"
        >
          nesse documento
        </Link>
        .
      </Text>

      <Title>6. Consigo controlar ou excluir cookies?</Title>
      <Text className="mt-4">
        Para que a Plataforma/Website opere corretamente, você deverá habilitar o uso dos Cookies. Caso decida não os
        habilitar, você ainda poderá navegar no site, mas algumas (ou muitas) funcionalidades não estarão disponíveis.
        <br />
        <br />
        Lembrando que a maioria dos navegadores de internet é configurada para aceitar automaticamente os Cookies.
        <br />
        <br />
        Você pode alterar as configurações para bloquear o uso de Cookies ou alertá-lo quando um Cookie estiver sendo
        enviado para o seu dispositivo. Existem várias formas de gerenciar Cookies, consulte as instruções de seu
        navegador ou a seção de ajuda para saber mais sobre como ajustar ou alterar essas configurações.
        <br />
        <br />
        Caso você utilize dispositivos diferentes para acessar o site, deverá assegurar-se de que cada navegador, de
        cada dispositivo, esteja ajustado para atender às suas preferências em relação aos Cookies.
      </Text>

      <footer className="mt-10 flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
        <Link
          href="/politica-de-privacidade"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de privacidade
        </Link>
        <Link
          href="/politica-de-cookies"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de cookies
        </Link>
        <Link
          href="/termos-de-uso"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de uso
        </Link>

        <Link
          href="/termos-de-contrato"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de Contrato
        </Link>
      </footer>
    </div>
  );
};

export default CookiesPolicy;
